function NotificationsCtrl($scope, $state, $timeout, Upload){
    var $sideBar = $('#sidebar');
    var sideBarWidth = $sideBar.length > 0 ? ($sideBar.width() - 15) : 300;

    $scope.init = function(){
        $timeout(function() {
            $scope.notification = {
                severity: 'LOW',
                creationDate: new Date().getTime()
            };
        }, 0);
    };

    store.fetch({
        path: '/getAllTags',
        success: function(data){
            $scope.$apply(function() {
                $scope.tags = data;
            });
        }
    });

    $scope.severities = {
        'LOW': 'Low',
        'MEDIUM': 'Medium',
        'HIGH': 'High',
        'CRITICAL': 'Critical'
    };

    $scope.accountTypes = {
        'SYSTEM': 'Cato System',
        'RESELLER': 'Reseller',
        'REGULAR': 'Regular'
    };

    $scope.categories = {
        'INFORMATION': 'Information',
        'WARNING': 'Warning',
        'ERROR': 'Error',
        'SECURITY': 'Security',
        'ACTIONABLE': 'Actionable'
    };

    $scope.clear = function(){
        $scope.$root.confirm('Are you sure you would like to clear the form?', function(){
            $scope.init();
        });
    };

    $scope.save = function(){
        if($scope.notification.expiration && $scope.notification.expiration.getTime()){
            $scope.notification.expirationDate = $scope.notification.expiration.getTime();
        }
        else {
            $scope.notification.expirationDate = null;
        }

        $scope.notification.targetAccounts = [];
        $scope.targetAccountsList.forEach(function (targetAccount) {
            $scope.notification.targetAccounts.push(targetAccount.id);
        });

        store.save({
            path: '/ag/createSystemNotification',
            data: $scope.notification,
            dataObj: 'notification',
            success: function(data){
                $scope.$root.handleServerResponse(data,"", "Notification" + ($scope.notification.targetAccounts.length > 0 ? "s" : "") + " saved successfully");
            }
        })
    };

    // storing all accounts to be notify on
    $scope.targetAccountsList = [];

    // configuration for the target accounts option
    $scope.targetAccountTableConfig = {
        dataURL : function() {
            return "/accounts?&viewType=SimpleList&enablePaging=true&showMe=true";
        },
        fields : [
            {"label": "Name", "path": "name", "template": "<span>{{item.name}}</span>"}
        ],
        actions: [],
        selectedItems: [],
        pageSize: 6,
        titleSearch: true,
        sortField: "name",
        searchField: "name",
        type: "Account"
    };

    // selection of target accounts options
    $scope.openAddTargetAccountsDlg = function(){
        $scope.targetAccountTableConfig.selectedItems = [];
        $scope.targetAccountsList.forEach(function (targetAccount) {
            $scope.targetAccountTableConfig.selectedItems.push(targetAccount);
        });

        $scope.$root.openPopup("selectTargetAccountDlg");
    };

    // collecting all target accounts from table config and store them in the scope list
    $scope.addTargetAccountItem = function () {
        $scope.targetAccountsList.length = 0;
        $scope.targetAccountTableConfig.selectedItems.forEach(function (targetAccount) {
            $scope.targetAccountsList.push(targetAccount);
        });
        $scope.targetAccountTableConfig.selectedItems = [];

        $scope.$root.closePopup('selectTargetAccountDlg');
    };

    // -- init

    $scope.init();
}